import React, { Fragment, useState } from 'react';
import RichTextEditor from 'legacy/src/components/content/editor/types/shared/RichTextEditor';
import cn from 'classnames';
import makeCursor from 'legacy-src/utility/Cursor';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Icon } from 'legacy/packages/ft-cb';
import Button from 'chameleon/ui-stack/ui/base/button';

import { useScoring } from './ScoringProvider';

import EditScoringCriterias from './EditScoringCriterias';

const EditScoringPointComponent = ({
  sectionIndex,
  pointIndex,
  criterias,
  feedbackCursor,
  additionalFeedbackCursor,
  handleRemovePoints,
  feedbackValidation,
  getCriteriaValidation = () => {},
}) => {
  const dispatch = useScoring()[1];
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const handleAddScoringCriteria = () => {
    dispatch({ type: 'addCriteria', payload: { sectionIndex, pointIndex } });
  };

  const handleUpdateScoringCriteria = (description, index) => {
    dispatch({
      type: 'updateCriteria',
      payload: { description, sectionIndex, pointIndex, index },
    });
  };

  const handleRemoveScoringCriteria = (index) => {
    dispatch({
      type: 'removeCriteria',
      payload: { sectionIndex, pointIndex, index },
    });
  };

  return (
    <Fragment>
      <div className="ScoreCategoryEditor__score border-t border-gray-900 mt-20 pt-6">
        <div className="ScoreCategoryEditor__point_header">
          <h3 data-test-points-label className="font-heading font-bold text-22">
            {pointIndex} {pointIndex === 1 ? 'Point' : 'Points'}
          </h3>
          {pointIndex > 1 && (
            <span
              role="button"
              tabIndex={0}
              className="ScoreCategoryEditor-remove-point-section"
              onClick={() => setShowConfirmationDialog(true)}
            >
              <Icon data-test-remove-point-icon name="trash" size="2.6rem" />
            </span>
          )}
          {showConfirmationDialog && (
            <ConfirmDialog
              title="Confirm"
              onClose={() => setShowConfirmationDialog(false)}
              onSuccess={() => {
                handleRemovePoints(pointIndex);
                setShowConfirmationDialog(false);
              }}
              aria={{
                live: 'polite',
              }}
              content={{
                btnSecondary: 'No',
                btnPrimary: 'Yes',
              }}
            >
              <p id="delete-scoring-point-warning">
                Are you sure you want to delete this point section?
                <br />
                This action cannot be undone and your changes will be lost.
              </p>
            </ConfirmDialog>
          )}
        </div>

        <div className="ScoreCategoryEditor__score_feedback_container">
          <h4 className="text-default text-gray-900 font-medium mb-4">
            Score Feedback
          </h4>
          <div className="content-column">
            <RichTextEditor
              data-test-feedback
              hasError={feedbackValidation}
              valueLink={feedbackCursor}
              placeholder="Feedback"
            />
          </div>
          {feedbackValidation && (
            <div className="action-column error-message --offset">
              {feedbackValidation}
            </div>
          )}
        </div>
        <div className="ScoreCategoryEditor__score_criteria_container">
          {criterias.map((criteria, index) => {
            const criteriaCursor = makeCursor(
              criteria.description,
              [],
              (data) => handleUpdateScoringCriteria(data, index),
            );
            return (
              <EditScoringCriterias
                key={`${index}$_{criteria_index}`}
                criteriaIndex={index}
                criteriaCursor={criteriaCursor}
                criteriaValidation={getCriteriaValidation(index)}
                showAddCriteriaButton={index === criterias.length - 1}
                handleRemoveScoringCriteria={handleRemoveScoringCriteria}
                handleAddScoringCriteria={handleAddScoringCriteria}
              />
            );
          })}
          {criterias.length === 0 ? (
            <div className="action-column my-10">
              <Button
                isPrimary
                className={cn('ScoreCategoryEditor__add_criteria')}
                onClick={handleAddScoringCriteria}
              >
                + Add Checkbox
              </Button>
            </div>
          ) : null}
        </div>
        <div className="ScoreCategoryEditor__score_feedback_container">
          <h4 className="text-default text-gray-900 font-medium mb-4">
            Additional Feedback
          </h4>
          <div className="content-column">
            <RichTextEditor
              data-test-additional-feedback
              valueLink={additionalFeedbackCursor}
              placeholder="Additional Feedback"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditScoringPointComponent;
